<template>
  <ul class="list-select">
    <li
      v-for="item in items"
      :key="item.value"
      class="list-select__item"
      :class="{
        'list-select__item--selected': item.value === value,
      }"
      @click="$emit('input', item.value)"
    >
      <i v-if="item.icon" class="list-select__icon material-icons">
        {{ item.icon }}
      </i>
      {{ item.label }}
    </li>
  </ul>
</template>

<script>
export default {
  name: 'ListSelect',
  props: {
    items: {
      type: Array,
      required: true,
    },
    // Value can be of any type
    // eslint-disable-next-line vue/require-prop-types
    value: {
      required: true,
    },
  },
};
</script>

<style lang="scss">
.list-select {
  padding: 0;
  margin: 0;

  &__item {
    list-style-type: none;

    display: flex;
    align-items: center;

    height: rem-calc(30px);
    cursor: pointer;

    border-radius: $lb-border-radius * 2;

    transition-duration: 0.3s;

    padding: 0 $global-padding / 4;

    user-select: none;

    border: 1px solid transparent;

    &:not(:last-child) {
      margin-bottom: calc($global-margin / 4);
    }

    &:hover {
      background-color: $lb-light-gray;
    }

    &--selected {
      border-color: $lb-color-success;
    }
  }

  &__icon {
    font-size: rem-calc(16px);

    margin-right: $global-margin / 4;
    @include rtl() {
      margin-left: $global-margin / 4;
      margin-right: 0;
    }
  }
}
</style>
